import React, { Component } from "react"
import { connect } from "react-redux"
import { Link } from "react-router"
import YouTube from "react-youtube"
import Moment from "moment"
import * as actions from "../../actions/event_edit"

const opts = {
  height: "390",
  width: "640",
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 0
  }
}

export class EventShow extends Component {
  componentDidMount() {
    this.props.getEvent(this.props.params.id)
  }

  render() {
    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      return (
        <div>
          <div className="float-xs-right">
            <Link
              className="btn btn-success"
              to={"/events/" + this.props.event._id + "/edit"}
            >
              <strong>EDIT</strong>
            </Link>
          </div>
          <h1>{this.props.event.name}</h1>
          {this.props.event.eventColor === "purple"
            ? <p>
                <span className="eventColorBlock purple" />
                {" "}General events & info
              </p>
            : this.props.event.eventColor === "teal"
                ? <p>
                    <span className="eventColorBlock teal" />
                    {" "}Focus dinners, supper club, onsite visits & open events
                  </p>
                : this.props.event.eventColor === "yellow"
                    ? <p>
                        <span className="eventColorBlock yellow" />
                        {" "}Annual conferences & award dinners
                      </p>
                    : this.props.event.eventColor === "red"
                        ? <p>
                            <span className="eventColorBlock red" />
                            {" "}Exchange programme
                          </p>
                        : <p>No event type</p>}

          <div className="well">
            <p>{this.props.event.details}</p>
            <p>
              <strong>Starts</strong>
              :{" "}
              {Moment(this.props.event.startTime)
                .utc()
                .format("dddd, MMMM Do YYYY, h:mm:ss a")}
            </p>
            <p>
              <strong>Ends</strong>
              :{" "}
              {Moment(this.props.event.endTime)
                .utc()
                .format("dddd, MMMM Do YYYY, h:mm:ss a")}
            </p>
            <p><strong>Cost</strong>: {this.props.event.cost}</p>

            <p>
              <strong>Booking Link</strong>:&nbsp;
              <a href={this.props.event.bookingLink} target="_blank">
                {this.props.event.bookingLink}
              </a>
            </p>

          </div>

          {this.props.event.displayVideo
            ? <div className="well">
                <p><strong>Video</strong></p>
                <YouTube
                  videoId={this.props.event.videoUrl}
                  opts={opts}
                  onReady={this._onReady}
                />

                {/*<p>{this.props.event.videoDetails}</p>
                <p>
                  <strong>Display Video?</strong>
                  :{" "}
                  {this.props.event.displayVideo.toString()}
                </p>*/}
              </div>
            : <p>No video for this event</p>}

          {this.props.event.displayPodcast
            ? <div className="well">
                <p><strong>Podcast</strong></p>
                <audio controls>
                  <source src={this.props.event.podcastUrl} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>
            : <p>No podcast for this event</p>}

        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  //console.log('show state: ' +JSON.stringify(state))
  return {
    event: state.event.item,
    loading: state.event.loading
  }
}

export default connect(mapStateToProps, actions)(EventShow)



/** WEBPACK FOOTER **
 ** ./src/components/events/show.js
 **/